import {
  dateSplit
} from '@/util/date'
import {twoDecimalFull} from '@/util/util'
export const tableOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 310,
  index: false,
  column: [{
      label: '',
      prop: 'projectId',
      width: 40,
      solt: true
    },
    {
      label: '项目名称',
      prop: 'projectName',
      overHidden: true
    }, {
      label: '项目地址',
      prop: 'projectAddresses',
      formatter: Addresses,
      overHidden: true
    }
    , {
      label: '项目类型',
      prop: 'projectType',
      overHidden: true
    }
    , {
      label: '费用总计(元)',
      prop: 'price',
      formatter: getprice,
      overHidden: true
    }, {
      label: '发布人',
      prop: 'userName',
      overHidden: true
    }, {
      label: '发布时间',
      prop: 'createTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }, {
      label: '开工时间',
      prop: 'startTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd HH:ss',
      valueFormat: 'yyyy-MM-dd HH:ss'
    }, {
      label: '工时(天)',
      prop: 'duration'
    },{
      label: '项目状态',
      prop: 'state',
      overHidden: true,
      formatter: states
    }
  ]
}

export const tableOptionall = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 300,
  index: false,
  column: [{
      label: '',
      prop: 'projectId',
      width: 40,
      solt: true
    },
    {
      label: '工程名称',
      prop: 'projectName',
      overHidden: true
    }, {
      label: '工程地址',
      prop: 'projectAddresses',
      formatter: Addresses,
      overHidden: true
    }, {
      label: '企业名称',
      prop: 'companyName',
      overHidden: true
    }, {
      label: '发布人',
      prop: 'userName',
      overHidden: true
    }, {
      label: '发布时间',
      prop: 'createTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }, {
      label: '开工时间',
      prop: 'startTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd HH:ss',
      valueFormat: 'yyyy-MM-dd HH:ss'
    }, {
      label: '工时(天)',
      prop: 'duration'
    }, {
      label: '工程状态',
      prop: 'state',
      overHidden: true,
      formatter: states
    }
  ]
}

export const billOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 450,
  index: false,
  column: [{
      label: '',
      prop: 'projectId',
      width: 40,
      solt: true
    },
    {
      label: '项目单号',
      prop: 'projectId',
      overHidden: true
    },
    {
      label: '项目名称',
      prop: 'projectName',
      overHidden: true
    }, {
      label: '发布人',
      prop: 'userName',
      overHidden: true
    }, {
      label: '项目类型',
      prop: 'projectType',
      overHidden: true
    }, {
      label: '开工时间',
      prop: 'actualStartTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }, {
      label: '项目状态',
      prop: 'state',
      overHidden: true,
      formatter: states
    }, {
      label: '项目费用(元)',
      prop: 'price',
      overHidden: true,
      formatter: keepTwoDecimalFull
    }, {
      label: '额外费用(元)',
      prop: 'estimatePrice',
      overHidden: true,
      formatter: getEstimatePrice
    }, {
      label: '费用总计(元)',
      prop: 'priceSum',
      overHidden: true,
      formatter: keepTwoDecimalFull
    },
    {
      label: '支付状态',
      prop: 'payState',
      overHidden: true,
      formatter: getPayState
    }, {
      label: '开票状态',
      prop: 'invoiceState',
      overHidden: true,
      formatter: getInvoiceState
    }
  ]
}

export const billTableOption_request = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 440,
  index: false,
  selection : true,
  column: [
    {
      label: '项目单号',
      prop: 'projectId',
      overHidden: true
    },
    {
      label: '项目名称',
      prop: 'projectName',
      overHidden: true
    }, {
      label: '结项人',
      prop: 'userName',
      overHidden: true
    }, {
      label: '项目类型',
      prop: 'projectType',
      overHidden: true
    }, {
      label: '项目时间',
      prop: 'projectTime',
      overHidden: true,
      formatter: getProjectTime
    }, {
      label: '项目费用(元)',
      prop: 'price',
      overHidden: true,
      formatter: keepTwoDecimalFull
    }, {
      label: '额外费用(元)',
      prop: 'estimatePrice',
      overHidden: true,
      formatter: getEstimatePrice
    }, {
      label: '费用总计(元)',
      prop: 'priceSum',
      overHidden: true,
      formatter: keepTwoDecimalFull
    }
  ]
}

export const ticketOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 520,
  index: false,
  column: [{
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '收件人姓名',
      prop: 'contacts',
      overHidden: true
    }, {
      label: '电话号码',
      prop: 'phone',
      overHidden: true
    }, {
      label: '地址',
      prop: 'addressee',
      overHidden: true,
      formatter: getInvoiceAddress
    }, {
      label: '邮政编码',
      prop: 'zipCode',
      overHidden: true
    }
  ]
}


export const ticketTableOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 513,
  index: false,
  column: [{
      label: '',
      prop: 'projectIds',
      width: 40,
      solt: true
    },
    {
      label: '发票单号',
      prop: 'invoiceNum',
      overHidden: true
    },
    {
      label: '快递单号',
      prop: 'expressNum',
      overHidden: true,
      formatter:setDefaultValue
    }, {
      label: '快递公司',
      prop: 'expressName',
      overHidden: true,
      formatter:setDefaultValue
    },
    {
      label: '申请时间',
      prop: 'createTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }, {
      label: '申请人',
      prop: 'userName',
      overHidden: true,
      formatter: getCreateUserInfo
    },{
      label: '发票抬头',
      prop: 'companyName',
      overHidden: true,
      formatter: getCommpanyName
    }, {
      label: '开票金额(元)',
      prop: 'money',
      overHidden: true,
      formatter: keepTwoDecimalFull
    },
    {
      label: '发票类型',
      prop: 'invoiceType',
      overHidden: true,
      formatter:setInvoiceType
    }, {
      label: '发票状态',
      prop: 'state',
      overHidden: true,
      formatter: setInvoiceState
    }
  ]
}

export const plateformTicketTable = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 420,
  index: false,
  column: [
    {
      label: '',
      prop: 'id',
      width: 40,
      solt: true
    },
    {
      label: '申请企业',
      prop: 'companyName',
      overHidden: true,
      formatter: getCommpanyName
    },
    {
      label: '发票类型',
      prop: 'invoiceType',
      overHidden: true,
      formatter:setInvoiceType
    },
    {
      label: '开票金额(元)',
      prop: 'money',
      overHidden: true,
      formatter: keepTwoDecimalFull
    },
    {
      label: '申请时间',
      prop: 'createTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    },
    {
      label: '项目数量',
      prop: 'count',
      overHidden: true,
      formatter:setProCount
    },
    {
       label: '申请人',
       prop: 'userName',
       overHidden: true,
       formatter: getCreateUserInfo
     },
    {
      label: '收件地址',
      prop: 'address',
      overHidden: true,
      formatter:setAddress
    }
  ]
}

export const projectDetailOption = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: false,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: false,
  border: true,
  align: 'center',
  menuAlign: 'center',
  // height: window.innerHeight - 420,
  index: false,
  column: [
    {
      label: '项目单号',
      prop: 'projectId',
      overHidden: true,
      width:135
    },
    {
      label: '项目名称',
      prop: 'projectName',
      overHidden: true
    },
    {
      label: '发布人',
      prop: 'userName',
      overHidden: true,
      width:120
    },
    {
      label: '项目类型',
      prop: 'projectType',
      overHidden: true,
      width:120
    },

    {
      label: '费用总计(元)',
      prop: 'priceSum',
      overHidden: true,
      width:120,
      formatter: keepTwoDecimalFull

    },
    {
      label: '开工时间',
      prop: 'startTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      width:160
    },
    {
       label: '工作时长',
       prop: 'duration',
       overHidden: true,
       width:80
     }
  ]
}

export const projectInTicketTable = {
  addBtn: false,
  refreshBtn: false,
  columnBtn: true,
  editBtn: false,
  delBtn: false,
  menu: false,
  page: true,
  border: true,
  align: 'center',
  menuAlign: 'center',
  height: window.innerHeight - 420,
  index: false,
  column: [{
      label: '',
      prop: 'projectId',
      width: 40,
      solt: true
    },
    {
      label: '项目单号',
      prop: 'projectId',
      overHidden: true
    },
    {
      label: '项目名称',
      prop: 'projectName',
      overHidden: true
    }, {
      label: '结项人',
      prop: 'userName',
      overHidden: true
    }, {
      label: '项目类型',
      prop: 'projectType',
      overHidden: true
    }, {
      label: '项目时间',
      prop: 'actualStartTime',
      type: 'date',
      overHidden: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd'
    }, {
      label: '项目费用(元)',
      prop: 'price',
      overHidden: true,
      formatter: keepTwoDecimalFull
    }, {
      label: '额外费用(元)',
      prop: 'estimatePrice',
      overHidden: true,
      formatter: getEstimatePrice
    }, {
      label: '费用总计(元)',
      prop: 'priceSum',
      overHidden: true,
      formatter: keepTwoDecimalFull
    }
  ]
}

function Addresses(row, value) {
  return value[0].address;
}

function getInvoiceAddress(row) {
  let address=''
  if(row.isDefault==1){
    address ='<span class="el-tag el-tag--mini">默认地址</span> '+" "+
    row.provinceName + " " + row.cityName + " " + row.addressee
  }else{
    address =row.provinceName + " " + row.cityName + " " + row.addressee
  }

  return  address;
}

// function needTools(row, value) {
//   let needTools = JSON.parse(value);
//   let tags = "";
//   for (let i = 0; i < needTools.length; i++) {
//     tags += needTools[i].name + ' '
//   }
//   return tags;
// }


function workType(row, value) {
  let workType = JSON.parse(value);
  let tags = '';
  for (let i = 0; i < workType.length; i++) {
    if (workType[i].needNum > 0) { //去除需求为0 的数据
      let _name = workType[i].workTypeName ? workType[i].workTypeName : workType[i].name
      tags += '<span class="el-tag el-tag--mini" style="margin-left:5px;">' + _name + '(' + workType[i].needNum + ')人' +
        '</span>'
    }
  }
  return tags;
}


function states(row, value) {
  let state;
  if (value === -2) {
    state = '<span class="el-tag el-tag--mini">项目取消</span>'
  } else if (value === -1) {
    state = '<span class="el-tag el-tag--mini">未发布</span>'
  } else if (value === 0) {
    state = '<span class="el-tag el-tag--mini">正在招募</span>'
  } else if (value === 1) {
    state = '<span class="el-tag el-tag--mini">等待执行</span>'
  } else if (value === 2) {
    state = '<span class="el-tag el-tag--warning el-tag--mini">项目取消</span>'
  } else if (value === 3) {
    state = '<span class="el-tag el-tag--warning el-tag--mini">项目超时</span>'
  } else if (value === 4) {
    state = '<span class="el-tag el-tag--success el-tag--mini">正在执行</span>'
  } else if (value === 5) {
    state = '<span class="el-tag el-tag--success el-tag--mini">申请结项</span>'
  } else if (value === 6) {
    state = '<span class="el-tag el-tag--warning el-tag--mini">拒绝结项</span>'
  } else if (value === 7) {
    state = '<span class="el-tag el-tag--info el-tag--mini">项目完结</span>'
  }
  return state;
}

function getEstimatePrice(row) {
  let num = (row.priceSum - row.price == 0 ? '' : (row.priceSum - row.price));
  return twoDecimalFull(num)
}


function keepTwoDecimalFull(row,num) {
  return twoDecimalFull(num);
}


//0未开票，1申请中，2已开票
function getInvoiceState(row, value) {
  let invoiceState;
  if (value == 0) {
    invoiceState = '未开票'
  } else if (value == 1) {
    invoiceState = '申请中'
  } else if (value == 2) {
    invoiceState = '已开票'
  }
  return invoiceState;
}

function getPayState(row) {
  let payState;
  if (row.state == 7) {
    payState = '已支付'
  } else {
    payState = '未支付'
  }
  return payState;
}

function getProjectTime(row) {
  let projectTime;
  if (row.actualStartTime || row.actualStopTime) {
    let start = dateSplit(row.actualStartTime, 3)
    let stop = dateSplit(row.actualStopTime, 3)
    projectTime = (start ? start : '--- ') + ' 至 ' + (stop ? stop : ' ---')
  }
  return projectTime
}

function getCreateUserInfo(row) {
  let userName;
  if(row.createUserInfo){
    userName=(JSON.parse(row.createUserInfo)).company.userName
  }
  return userName
}

function getCommpanyName(row ){
  let companyName;
  if(row.companyInvoiceInfo&&row.companyInvoiceInfo!='null'){
    console.log(row);
    companyName=(JSON.parse(row.companyInvoiceInfo)).commpanyName
  }
  return companyName
}

function setInvoiceType(row){
  let invoiceType;
  if(row.invoiceType==2){
    invoiceType='增值税专用发票'
  }else if(row.invoiceType==1){
    invoiceType='增值税普通发票'
  }
  return invoiceType
}
 function setInvoiceState(row ){
   let state;
   if(row.state!=2){
     state='申请中'
   }else if(row.state==2){
     state='已开票'
   }
   return state
 }

function setDefaultValue(row,value,column,label){
  if(!row.expressNum){
    return '-'
  }
  if(!row.expressName){
    return '-'
  }
  if(row.expressNum||row.expressName){
    if(label.label=='快递单号'){
      return row.expressNum
    }else{
      return row.expressName
    }
  }

}

function setProCount(row){
  let count;
  if(row.projectIds){
    count=row.projectIds.split(',').length
  }
  return count?count:0
}

function setAddress(row){
  let adrs,pro,city,area;
  if(row.addressInfo){
    let obj=JSON.parse(row.addressInfo);
    pro=obj.provinceName?obj.provinceName:'';
    city=obj.cityName?obj.cityName:'';
    area=obj.areaName?obj.areaName:'';
    adrs=obj.addressee?obj.addressee:'';
  }
  return pro+city+area+adrs
}

function setWorkers(row){
  let workers='';
  if(row.workTypes){
    let workType=row.workTypes
    for (let i = 0; i < workType.length; i++) {
      if (workType[i].needNum > 0) { //去除需求为0 的数据
        let _name = workType[i].workTypeName ? workType[i].workTypeName : workType[i].name;
        workers += '<span class="el-tag el-tag--mini" style="margin-left:5px;">' + _name + '(' + workType[i].needNum + ')人' +
          '</span>'
      }
    }
  }
  return workers
}

function getprice(row){
  if(row.priceSum){
    return twoDecimalFull(row.priceSum)
  }else if(row.price){
    return twoDecimalFull(row.price)
  }else{
    return '-'
  }
}
